import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelGetEmdPassengerReceiptRequest,
  failGetEmdPassengerReceipt,
  setGetEmdPassengerReceipt,
  setGetEmdPassengerReceiptFromApi,
  updateGetEmdPassengerReceipt,
  updateGetEmdPassengerReceiptFromApi,
} from './get-emd-passenger-receipt.actions';

/**
 * Service to handle async GetEmdPassengerReceipt actions
 */
@Injectable()
export class GetEmdPassengerReceiptEffect {
  /**
   * Set the state with the reply content, dispatch failGetEmdPassengerReceipt if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetEmdPassengerReceiptFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetEmdPassengerReceipt({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetEmdPassengerReceipt({ error, requestId: action.requestId })),
        cancelGetEmdPassengerReceiptRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetEmdPassengerReceipt if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetEmdPassengerReceiptFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetEmdPassengerReceipt({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetEmdPassengerReceipt({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
